"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _inlineEditableDiv = require("./inlineEditableDiv");

var _inlineEditableDiv2 = _interopRequireDefault(_inlineEditableDiv);

var _inlineReadOnlyDiv = require("./inlineReadOnlyDiv");

var _inlineReadOnlyDiv2 = _interopRequireDefault(_inlineReadOnlyDiv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InlineDiv = function InlineDiv(props) {
  var isEditMode = props.isEditMode,
      className = props.className,
      keyProperty = props.keyProperty,
      property = props.property,
      setData = props.setData,
      updateProps = props.updateProps,
      value = props.value;


  if (isEditMode) return _react2.default.createElement(_inlineEditableDiv2.default, {
    value: value,
    className: className,
    updateProps: updateProps,
    property: property,
    keyProperty: keyProperty,
    setData: setData,
    isEditMode: isEditMode
  });

  return _react2.default.createElement(_inlineReadOnlyDiv2.default, { value: value, className: className });
};

exports.default = InlineDiv;